import { trackNormalComponent } from '../../util/trackComponent.js';
import { BaseTimelineContainer as TimelineContainerMemoized } from './TimelineContainer.js';
import './Marker/index.js';
import './Step/index.js';
import './Track/index.js';

var TimelineContainerWithTracking = trackNormalComponent(TimelineContainerMemoized);

export { TimelineContainerWithTracking as TimelineContainer };
//# sourceMappingURL=external.js.map
